import { render, staticRenderFns } from "./newQuestionDialog.vue?vue&type=template&id=69a28558&scoped=true&"
import script from "./newQuestionDialog.vue?vue&type=script&lang=js&"
export * from "./newQuestionDialog.vue?vue&type=script&lang=js&"
import style0 from "./newQuestionDialog.vue?vue&type=style&index=0&id=69a28558&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a28558",
  null
  
)

export default component.exports